export default __webpack_public_path__ + "static/media/slovenia.d38544bc.png";